import List from 'components/Common/List'
import Group from 'components/utils/Group'
import Heading from 'LuxKit/Typography/Heading'
import BodyText from 'LuxKit/Typography/BodyText'
import BodyTextBlock from 'LuxKit/TextBlocks/BodyTextBlock'
import LineArrowsRightDownIcon from 'LuxKit/Icons/line/LineArrowsRightDownIcon'
import { useIntl } from 'react-intl'
import AccommodationAmenitiesAndPoliciesContent from 'components/AccommodationKit/AccommodationAmenitiesAndPoliciesContent'

interface Props {
  pkg: App.Package
}

function FlashHotelAboutRoomModalTab(props: Props) {
  const { pkg } = props
  const intl = useIntl()

  const amenities = pkg.roomType?.amenities
  const policyDescription = pkg.roomPolicyDescription

  return (
    <Group direction="vertical" gap={32}>
      {!!pkg.roomType?.description && <BodyText variant="medium">{pkg.roomType?.description}</BodyText>}
      <Group direction="vertical" gap={12}>
        <Heading variant="heading4">
          {intl.formatMessage({
            id: 'pi2LiSGCGhaXeZAJ1KDo',
            defaultMessage: 'Room Options',
          })}
        </Heading>
        <BodyTextBlock variant="medium" startIcon={<LineArrowsRightDownIcon />}>
          {intl.formatMessage({
            id: 'Rl7jb7t-iJpUyMW3fmlI',
            defaultMessage: '{size} m\u00B2',
          }, { size: pkg.roomType?.sizeSqm })}
        </BodyTextBlock>
      </Group>
      {!!amenities?.length && <Group direction="vertical" gap={12}>
        <Heading variant="heading4">
          {intl.formatMessage({
            id: 'nNP5-Fyyu-eRFuUh70sA',
            defaultMessage: 'Room Amenities',
          })}
        </Heading>
        <List>
          {amenities.map(amenity => <BodyText
            key={amenity.description}
            as="li"
            variant="medium"
          >
            {amenity.description}
          </BodyText>)}
        </List>
      </Group>}
      {policyDescription && <AccommodationAmenitiesAndPoliciesContent
        roomPackage={pkg as App.HotelPackage}
        headingVariant="heading5"
        policyFontSize="medium"
        hideAmenities
      />}
    </Group>
  )
}

export default FlashHotelAboutRoomModalTab
